var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10002 12.8416H10.9C11.0857 12.8416 11.2637 12.9132 11.395 13.0407C11.5263 13.1683 11.6 13.3412 11.6 13.5216C11.6 13.7019 11.5263 13.8749 11.395 14.0024C11.2637 14.1299 11.0857 14.2016 10.9 14.2016H1.10002C0.914373 14.2016 0.736325 14.1299 0.60505 14.0024C0.473774 13.8749 0.400024 13.7019 0.400024 13.5216C0.400024 13.3412 0.473774 13.1683 0.60505 13.0407C0.736325 12.9132 0.914373 12.8416 1.10002 12.8416ZM0.400024 9.44156L7.40002 2.64156L9.50002 4.68156L2.50002 11.4816H0.400024V9.44156ZM8.10002 1.96156L9.50002 0.601562L11.6 2.64156L10.1993 4.00224L8.10002 1.96156Z",
    fill: "#2B3990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f48c9e555825bd36908de75e9f0798b0.svg";
export { ForwardRef as ReactComponent };